module.exports = new __parcel__URL__("closeIco.b2523443.svg").toString();